import { createApp } from 'vue'
import { preloadBrandFromTemplates } from '@/libs/brandFromTemplates'
import App from './App'
import i18n from './i18n'

async function bootstrap() {
  // router 建立時需要 brand 過濾路由，先載入 template（失敗仍會用 hostname 後備）
  await preloadBrandFromTemplates().catch((error) => {
    console.error('[bootstrap] preloadBrandFromTemplates failed', error)
  })
  const { default: router } = await import('./router')
  createApp(App).use(i18n).use(router)
    .mount('#app')
}

bootstrap()
